import { render, staticRenderFns } from "./library.vue?vue&type=template&id=bf7556d2&scoped=true&"
import script from "./library.vue?vue&type=script&lang=js&"
export * from "./library.vue?vue&type=script&lang=js&"
import style0 from "./library.vue?vue&type=style&index=0&id=bf7556d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7556d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7556d2')) {
      api.createRecord('bf7556d2', component.options)
    } else {
      api.reload('bf7556d2', component.options)
    }
    module.hot.accept("./library.vue?vue&type=template&id=bf7556d2&scoped=true&", function () {
      api.rerender('bf7556d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormCreate/File/library.vue"
export default component.exports